/**
 *
 * Asynchronously loads the component for PneumaticIcon
 *
 */

import { lazyLoad } from 'utils/loadable';

export const PneumaticIcon = lazyLoad(
  () => import('./index'),
  module => module.PneumaticIcon,
);
